<template>
  <div class="row" style="padding: 0px 5px 0px 5px;">
    <div class='alert alert-danger alert-dismissable' v-if='CollectorsvalidationErrors'>
      <ul v-if='CollectorsvalidationErrors'>
        <li v-for='err in CollectorsvalidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
      </ul>
    </div>
    <div class='alert alert-success alert-dismissable' v-if='CollectorsSuccess'>
      {{CollectorsSuccess}}
    </div>
    <div class="row" style="padding: 15px 18px 0px 18px;">
      <div class='form-group col-lg-4 col-sm-4'>
        <label>الفرع:</label>
        <select @change="GetDistributedReceipts()" class="form-control"  v-model="branch_id" >
          <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class='form-group col-lg-4 col-sm-4'>
        <label>الفنى:</label>
        <select class="form-control" style="padding: 0px" v-model="modelCollectorId">
          <option v-for="(item) in modelCollectors" v-bind:key="item.id" v-bind:value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class='form-group col-lg-4 col-sm-4'>
        <tbDate :today='today' :mytitle='folderDate' v-model= 'folder_date' ></tbDate>
      </div>
        <div style="padding-right: 25%" class='form-group col-lg-4 col-sm-4'>
        <StreamBarcodeReader
            @decode="onDecode"
        ></StreamBarcodeReader>
      </div>
      <div class='form-group col-lg-12 col-sm-12'>
        <button @click='saveData()' type='button' class='btn btn-primary btn-md btn-block'>حفظ</button>
      </div>

        <div class='form-group col-lg-12 col-sm-12'>
      <table width='100%' class='table table-striped table-bordered table-hover' >
        <thead>
          <tr>
            <th style='padding:2px;text-align: center;'>م</th>
            <th style='padding:2px;text-align: center'>الكود</th>
            <th style='padding:2px;text-align: center'>الاسم</th>
          </tr>
        </thead>
        <tbody>
          <tr class='odd gradeX' v-for='(record,index) in selectedRecords' :key='record.rec_id'>
            <td align='center'>{{index +1 }}</td>
            <td align='center'>{{record.rec_id}}</td>
            <td align='center'>{{record.name}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>
</template>
<script>
import axios from 'axios'
// import StreamBarcodeReader from 'vue-barcode-reader'
import tbDate from '@/components/myComponents/tbDate'
import { StreamBarcodeReader } from 'vue-barcode-reader'
export default {
  components: {
    StreamBarcodeReader,
    tbDate
  },
  name: 'DistributionReceipts',
  data () {
    return {
      branches: {},
      branch_id: 0,
      modelCollectors: {},
      today: true,
      folderDate: 'تاريخ الحافظة',
      folder_date: '',
      modelCollectorId: '',
      records: [],
      selectedRecords: [],
      CollectorsSuccess: '',
      CollectorsvalidationErrors: '',
      valueScaned: ''
    }
  },
  methods: {
    loadCom (records, modelCollectors) {
      this.records = records
      this.modelCollectors = modelCollectors
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      this.branch_id = JSON.parse(localStorage.getItem('BrancheID'))
      this.UpdateCollectors()
    },
    // ======================================================
    UpdateCollectors () {
      this.collector_id = 0
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch_id))
      if (i > -1) {
        this.collectors = this.branches[i].collectors
        this.collectors.unshift(this.emptyRec)
      }
    },
    // ======================================================
    onDecode (result) {
      this.valueScaned = result
      let r = this.selectedRecords.map(record => record.id).indexOf(parseInt(this.valueScaned))
      if (r === -1) {
        let i = this.records.map(record => record.id).indexOf(parseInt(this.valueScaned))
        if (i > -1) {
          this.selectedRecords.push(Array.from(this.records)[i])
          this.playSound()
        }
      }
    },
    // ======================================================
    playSound () {
      let sound = 'http://soundbible.com/mp3/Elevator Ding-SoundBible.com-685385892.mp3'
      if (sound) {
        var audio = new Audio(sound)
        audio.play()
      }
    },
    // ======================================================
    saveData () {
      let Receipts = []
      this.selectedRecords.forEach(element =>
        Receipts.push(element.id)
      )
      this.CollectorsSuccess = ''
      this.CollectorsvalidationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'set-distributed-receipts', {
        token: localStorage.getItem('token'),
        CollectorId: this.modelCollectorId,
        folderDate: this.folder_date,
        receipts: Receipts
      })
        .then(res => {
          this.isLoadingSave = false
          this.CollectorsSuccess = 'تم الحفظ بنجاح'
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.CollectorsvalidationErrors = err.response.data.errors
          this.isLoadingSave = false
        })
    }
    // ===========================================================
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/DistributionReceipts.vue